module.exports = __webpack_public_path__ + "static/media/2025-profile.e51c01ed.jpeg";